import React from "react";
import Swal from "sweetalert2";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import useApi from "../../hooks/useApi";
import usePagination from "../../hooks/usePagination";
import useApp from "../../hooks/useApp";

const DeferredCommission = () => {
  const { Paginate } = usePagination();
  const { api, abortSignal, auth } = useApi();
  const { state = "pending" } = useParams();
  const { showAlert } = useApp();

  const getDeferredCommissions = async () => {
    try {
      const url = `/commissions/deferred/${state}`;
      const { data } = await api.list(url);
      return data;
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data: deferredCommissions, refetch } = useQuery(
    ["deferredCommissions", auth, state],
    ({ queryKey }) => getDeferredCommissions()
  );

  const handleApprove = async (id) => {
    const { value: comment, isConfirmed } = await Swal.fire({
      title: "Are you sure?",
      text: "You want to approve!",
      icon: "warning",
      input: "textarea",
      inputLabel: "",
      inputPlaceholder: "Type your comment here...",
      inputAttributes: {
        "aria-label": "Type your message here",
        required: true,
      },
      inputValidator: (value) => {
        if (!value) {
          return "You need to enter comment";
        }
      },
      confirmButtonText: "Yes, Approve",
      showCancelButton: true,
    });

    if (isConfirmed) {
      try {
        const data = { comment: comment || "" };
        const response = await api.update(
          `/commissions/deferred/${id}/approve`,
          data
        );
        if (response.ok) {
          showAlert("Approved", "success");
          refetch();
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleDecline = async (id) => {
    const { value: comment, isConfirmed } = await Swal.fire({
      title: "Are you sure?",
      text: "You want to decline!",
      icon: "warning",
      input: "textarea",
      inputLabel: "",
      inputPlaceholder: "Type your comment here...",
      inputAttributes: {
        "aria-label": "Type your message here",
        required: true,
      },
      inputValidator: (value) => {
        if (!value) {
          return "You need to enter comment";
        }
      },
      confirmButtonText: "Yes, Decline",
      showCancelButton: true,
    });

    if (isConfirmed) {
      try {
        const data = { comment: comment || "" };
        const response = await api.update(
          `/commissions/deferred/${id}/decline`,
          data
        );
        if (response.ok) {
          showAlert("Declined", "success");
          refetch();
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      {deferredCommissions &&
      Array.isArray(deferredCommissions) &&
      deferredCommissions.length > 0 ? (
        deferredCommissions?.map((deferredCommission) => (
          <div className="card flex-row mb-3" key={deferredCommission?.id}>
            <div className="w-350px flex-shrink-0 py-2 px-2 text-center bg-warning1 rounded-start">
              <ul className="list-group text-white">
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Client
                  <span className=" fs-5 fw-bold">
                    {deferredCommission?.PolicyItem?.Policy?.Client?.name}
                  </span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Policy
                  <span className="">
                    {deferredCommission?.PolicyItem?.PolicyType?.name}(
                    {deferredCommission?.PolicyItem?.Product?.name})
                  </span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Company
                  <span className="">
                    {deferredCommission?.PolicyItem?.Company?.name}
                  </span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Branch
                  <span className="">
                    {deferredCommission?.PolicyItem?.Branch?.name}
                  </span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Premium
                  <span className="badge bg-secondary rounded-pill fs-5">
                    {deferredCommission?.PolicyItem?.policyCurrency}{" "}
                    {new Number(
                      deferredCommission?.PolicyItem?.premium
                    ).toLocaleString("en-US")}
                  </span>
                </li>
              </ul>
            </div>
            <div className="card-body d-flex flex-column w-160px">
              <div className="d-flex align-items-center justify-content-between mb-3">
                {/* <a href="#" className="h5 btn-link text-truncate m-0 pe-3">
              These sweet mornings of spring which I enjoy with my whole heart
            </a> */}

                {deferredCommission?.state == 0 && (
                  <div className="ms-auto text-center text-nowrap text-muted">
                    <button
                      className="btn btn-xs btn-hover btn-success me-2"
                      onClick={() => handleApprove(deferredCommission?.id)}
                    >
                      <i className="demo-pli-like fs-5 me-2"></i>Approve
                    </button>
                    <button
                      className="btn btn-xs btn-hover btn-danger"
                      onClick={() => handleDecline(deferredCommission?.id)}
                    >
                      Decline
                    </button>
                  </div>
                )}
              </div>
              {!deferredCommission?.state == 0 && (
                <div className="list-group">
                  <a
                    href="#"
                    className="list-group-item list-group-item-action"
                  >
                    <div className="d-flex w-100 justify-content-between">
                      <h5 className="mb-1">
                        {deferredCommission?.Approver?.name || ""}
                      </h5>
                      <small className="">
                        {"Date Processed: "}
                        {deferredCommission?.dateApproved}
                      </small>
                    </div>
                    <p className="mb-1">
                      {deferredCommission?.comment &&
                        `Comments: ${deferredCommission?.comment}`}
                    </p>
                  </a>
                </div>
              )}

              {/* <p>
            A small river named Duden flows by their place and supplies it with
            the necessary regelialia. It is a paradisematic country, in which
            roasted parts of sentences fly into your mouth.
          </p> */}
              <div className="mt-auto pt-3 border-top d-flex align-items-center">
                <div className="d-flex align-items-center gap-1">
                  {deferredCommission.state == 1 ? (
                    <div className="badge bg-success">Approved</div>
                  ) : deferredCommission.state == 2 ? (
                    <div className="badge bg-danger">Declined</div>
                  ) : (
                    <div className="badge bg-warning">Pending</div>
                  )}
                </div>
                <small className="ms-auto">
                  {deferredCommission?.createdAt}
                </small>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="">No record found</div>
      )}
      <Paginate />
    </>
  );
};

export default DeferredCommission;
